/* eslint-disable */
export default {
  noResultFoundFor: 'Nenhum resultado encontrado para',
  search: 'Pesquisar',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
